module.exports = __webpack_public_path__ + "img/TractionMpos2.1c6a1aa6.png";